'use strict';

function swiperGallery(selector) {
    // Inicjalizuj tylko normalne galerie (nie fullscreen)
    $(selector + ':not(.fullscreen)').each(function() {
        const $gallery = $(this);
        const $container = $gallery.find('.gallery-swiper-container');
        if (!$container.length) return;

        const isMobile = $(window).width() < 768;
        
        // Dla normalnej galerii: centerMode z widocznymi sąsiednimi
        const updateSideClasses = function() {
            $container.find('.slick-slide').removeClass('slide-prev slide-next');
            const $center = $container.find('.slick-center');
            $center.prev('.slick-slide').addClass('slide-prev');
            $center.next('.slick-slide').addClass('slide-next');
        };

        $container.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: !isMobile,
            centerPadding: isMobile ? '0' : 'clamp(100px, 16.56vw, 318px)',
            infinite: true,
            arrows: true,
            prevArrow: $gallery.find('.gallery-swiper-prev'),
            nextArrow: $gallery.find('.gallery-swiper-next'),
            speed: 300,
            cssEase: 'ease-out',
            on: {
                init: function() {
                    setTimeout(updateSideClasses, 10);
                },
                afterChange: function() {
                    updateSideClasses();
                }
            }
        });
    });

    $('.gallery-swiper:not(.fullscreen) a').on('click', function(e) {
        e.preventDefault();
        const $clickedSlide = $(this).closest('.slick-slide');
        const $normalGallery = $clickedSlide.closest('.gallery-swiper');
        const $normalContainer = $normalGallery.find('.gallery-swiper-container');
        const slideIndex = $normalContainer.slick('slickCurrentSlide');
        const galleryId = $(this).data('gallery-id');
        const $fullscreen = $(`#gallery-swiper-fullscreen-${galleryId}`);
        
        if ($fullscreen.length) {
            const $fullscreenContainer = $fullscreen.find('.gallery-swiper-container');
            
            // Inicjalizuj fullscreen jeśli jeszcze nie jest
            if (!$fullscreenContainer.hasClass('slick-initialized')) {
                $fullscreenContainer.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                    variableWidth: false,
                    infinite: true,
                    arrows: true,
                    prevArrow: $fullscreen.find('.gallery-swiper-prev'),
                    nextArrow: $fullscreen.find('.gallery-swiper-next'),
                    speed: 300,
                    cssEase: 'ease-out',
                    fade: false,
                    on: {
                        init: function() {
                            // Upewnij się, że wszystkie slajdy mają właściwą szerokość
                            $(this).find('.slick-slide').css({
                                'width': '100vw',
                                'min-width': '100vw',
                                'max-width': '100vw'
                            });
                        },
                        afterChange: function() {
                            const title = $fullscreen.find('.slick-current img').attr('title');
                            $fullscreen.find('.gallery-caption span').html(title && title.length > 2 ? title : '');
                        }
                    }
                });
            }
            
            // Przejdź do odpowiedniego slajdu
            setTimeout(function() {
                $fullscreenContainer.slick('slickGoTo', slideIndex, false);
                // Upewnij się, że wszystkie slajdy mają właściwą szerokość
                $fullscreenContainer.find('.slick-slide').css({
                    'width': '100vw',
                    'min-width': '100vw',
                    'max-width': '100vw'
                });
            }, 10);
            $fullscreen.addClass('show');
        }
    });

    $('.gallery-swiper.fullscreen .gallery-close, body').on('click keyup', function(e) {
        if ($(e.target).hasClass('gallery-close') || e.key === 'Escape') {
            $('.gallery-swiper.fullscreen').removeClass('show');
        }
    });
}

export default swiperGallery;
